/**
 * Parse META-INF/container.xml to find the OPF package path.
 */
export interface ContainerResult {
  packagePath: string;
  directory: string;
  encoding: string;
}

export function parseContainer(doc: Document): ContainerResult {
  const rootfile = doc.querySelector("rootfile");
  if (!rootfile) throw new Error("No rootfile found in container.xml");

  const packagePath = rootfile.getAttribute("full-path");
  if (!packagePath) throw new Error("rootfile missing full-path attribute");

  const lastSlash = packagePath.lastIndexOf("/");
  const directory = lastSlash >= 0 ? packagePath.slice(0, lastSlash + 1) : "";
  const encoding = (doc as any).xmlEncoding ?? "";

  return { packagePath, directory, encoding };
}
